import * as React from 'react'

import { useIsPasswordlessAuthEnabled } from './passwordless-auth-utils'
import { useFlag, FF } from '@local/do-secundo-feature-flag'
import { passwordlessStorageSet } from './passwordless-auth-storage'
import { dataByTypename } from '../../../../client/utils/apollo-helpers'
import { IMPORT_ACCOUNT, IMPORT_STATUS } from '../../index'
import { useMutation } from '@apollo/client'
import {
  deleteTokens,
  accountLinkingStorage
} from '../../../../client/apollo/authentication/authentication-helpers'

/**
 * Determines if the account linking feature should be visible to a user
 */
export const useIsAccountLinkingEnabled = () => {
  const { PASSWORDLESS_ENABLED } = useIsPasswordlessAuthEnabled()
  const ACCOUNT_LINKING_FF_ENABLED = useFlag(FF.ACCOUNT_PROFILE_LINKING)

  return PASSWORDLESS_ENABLED && ACCOUNT_LINKING_FF_ENABLED
}

/**
 * Returns a mutation function that links customermgmt accounts with passwordless accounts
 * and adds localstorage key/value which controls visibility of the alert to connect accounts
 * on an account page
 *
 */
export const useImportAccount = () => {
  const [importAccount] = useMutation(IMPORT_ACCOUNT, {
    refetchQueries: [{ query: IMPORT_STATUS }],
    awaitRefetchQueries: true
  })
  return async ({
    onSuccess,
    onError
  }: {
    onSuccess?: (e?: any) => void | any
    onError?: (e?: any) => void | any
  }) => {
    const importResult = await importAccount()
    const { ImportAccountResponse, ImportAccountError } = dataByTypename(
      importResult.data.importAccount
    )

    try {
      window.localStorage.removeItem('auth')
    } catch (err) {}

    if (ImportAccountResponse) {
      passwordlessStorageSet('connectNotificationDismissed', true)
      onSuccess && onSuccess()
    } else if (ImportAccountError) {
      onError && onError(ImportAccountError)
    }
    deleteTokens(accountLinkingStorage)
  }
}
